import React from "react";
import {connect} from "react-redux";
import {openModal} from "../../actions/modal";

class Button extends React.Component {

    render() {
        const {openModal} = this.props;

        return (
          <button onClick={() => openModal('member', [])} className={`btn btn-sm ${this.props.class}`}>{this.props.text}</button>
        )
    }
}

function mapStateToProps(state) {
    return {};
}

export default connect(mapStateToProps, {openModal})(Button);




// WEBPACK FOOTER //
// ./src/components/elements/Button.js